/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
import React from 'react';

const SubmitTitle = (props) => {
    const { 
        i18n,
        isShowIcon
    } = props;
    const isShow = (bool) => {
        return bool ? "" : " hidden";
    }; 
    return (
        <div className={"appoint-title-container"}>
            <div className={"icon icon-circle-confirmation-solid" + isShow(isShowIcon)}></div>
            <div data-key={i18n.dataKey + "-header"}>{i18n.title}</div>
            <div data-key={i18n.dataKey + "-dec"}>{i18n.dec}</div>
        </div>
    )
};
export default SubmitTitle;





// WEBPACK FOOTER //
// ./src/views/Appointment/components/SubmitTitle.js